export const Shield = (props) => (
  <svg viewBox="0 0 140 220" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="106" y1="10" x2="106" y2="212" />
    <path d="M106 2 L99 22 L113 22 Z" />
    <path d="M62 18 C96 34 96 186 62 206 C28 186 28 34 62 18 Z" />
    <line x1="62" y1="18" x2="62" y2="206" />
    <path d="M42 68 H82 M40 110 H84 M42 152 H82" />
    <path d="M54 46 V62 M70 46 V62 M54 158 V174 M70 158 V174" />
  </svg>
);

export const Calabash = (props) => (
  <svg viewBox="0 0 120 140" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M60 14 C78 14 82 30 76 40 C100 52 108 78 100 102 C92 126 76 134 60 134 C44 134 28 126 20 102 C12 78 20 52 44 40 C38 30 42 14 60 14 Z" />
    <path d="M46 26 H74" />
    <path d="M28 82 H92" />
    <path d="M32 82 L40 94 L48 82 L56 94 L64 82 L72 94 L80 82 L88 94" />
    <path d="M34 108 C46 116 74 116 86 108" />
  </svg>
);

export const Basket = (props) => (
  <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 32 H98 L85 106 H35 Z" />
    <path d="M14 32 H106" />
    <path d="M28 52 L38 62 L48 52 L58 62 L68 52 L78 62 L88 52" />
    <path d="M31 74 L40 83 L49 74 L58 83 L67 74 L76 83 L85 74" />
    <path d="M34 94 L42 101 L50 94 L58 101 L66 94 L74 101 L82 94" />
  </svg>
);

export const Maize = (props) => (
  <svg viewBox="0 0 120 160" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M60 22 C78 36 78 96 60 118 C42 96 42 36 60 22 Z" />
    <path d="M60 22 V118 M48 34 C52 70 52 92 54 110 M72 34 C68 70 68 92 66 110" />
    <path d="M47 52 H73 M46 74 H74 M48 96 H72" />
    <path d="M60 118 C42 112 28 94 25 68 C41 86 53 98 60 102" />
    <path d="M60 118 C78 112 92 94 95 68 C79 86 67 98 60 102" />
    <path d="M56 14 L60 22 L64 14" />
  </svg>
);

export const CowHead = (props) => (
  <svg viewBox="0 0 160 140" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M58 46 C40 30 24 24 8 32 C24 34 38 44 50 58" />
    <path d="M102 46 C120 30 136 24 152 32 C136 34 122 44 110 58" />
    <path d="M80 38 C100 38 108 56 104 78 C101 98 92 118 80 122 C68 118 59 98 56 78 C52 56 60 38 80 38 Z" />
    <path d="M56 60 C40 54 30 58 25 68 C37 71 48 71 56 68 Z" />
    <path d="M104 60 C120 54 130 58 135 68 C123 71 112 71 104 68 Z" />
    <path d="M68 74 H72 M88 74 H92" />
    <path d="M66 100 C66 108 72 114 80 114 C88 114 94 108 94 100" />
    <path d="M72 106 H73 M87 106 H88" />
  </svg>
);

export const GiftBox = (props) => (
  <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="24" y="50" width="72" height="54" />
    <rect x="17" y="34" width="86" height="16" />
    <line x1="60" y1="34" x2="60" y2="104" />
    <path d="M60 34 C48 20 34 24 38 32 C41 38 52 36 60 34 C68 36 79 38 82 32 C86 24 72 20 60 34 Z" />
  </svg>
);

export const Leaves = (props) => (
  <svg viewBox="0 0 120 140" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M60 134 V60" />
    <path d="M60 96 C40 92 28 76 30 56 C48 62 58 76 60 96 Z" />
    <path d="M60 76 C80 72 92 56 90 36 C72 42 62 56 60 76 Z" />
    <path d="M60 60 C52 40 54 22 60 8 C66 22 68 40 60 60 Z" />
  </svg>
);

const COW_SILHOUETTE =  "M30 12 C34 22 40 30 47 36 L45 40 C36 38 26 40 18 46 C20 52 30 55 42 55 " +
  "C40 62 40 70 42 78 C44 90 50 98 60 100 C70 98 76 90 78 78 C80 70 80 62 78 55 " +
  "C90 55 100 52 102 46 C94 40 84 38 75 40 L73 36 C80 30 86 22 90 12 " +
  "C84 16 76 22 70 30 C67 26 63 24 60 24 C57 24 53 26 50 30 C44 22 36 16 30 12 Z";

export const ZuluAttire = (props) => (
  <svg viewBox="0 0 120 160" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <ellipse cx="60" cy="22" rx="36" ry="9" />
    <path d="M32 22 C40 30 80 30 88 22" />
    <path d="M48 44 C52 52 68 52 72 44" />
    <path d="M48 44 C40 50 36 58 38 66 C42 78 46 84 46 92 L30 140 H90 L74 92 C74 84 78 78 82 66 C84 58 80 50 72 44" />
    <path d="M46 92 H74" />
    <path d="M48 92 L54 100 L60 92 L66 100 L72 92" />
    <path d="M38 118 H82 M34 130 H86" />
    <path d="M52 52 l2 3 M60 55 l0 3 M68 52 l-2 3" />
  </svg>
);

export const MonogramPlaque = (props) => (
  <svg viewBox="0 0 200 260" {...props}>
    <path
      d="M14 246 V96 A86 86 0 0 1 186 96 V246 Z"
      fill="#FAF8F5"
      stroke="rgba(197,160,89,0.55)"
      strokeWidth="1.5"
    />
    <g transform="translate(55,38) scale(0.75)">
      <path d={COW_SILHOUETTE} fill="#1A1A1A" />
    </g>
    <text
      x="76"
      y="212"
      textAnchor="middle"
      fontFamily="Cormorant Garamond, serif"
      fontWeight="500"
      fontSize="42"
      fill="#1A1A1A"
    >
      M
    </text>
    <line x1="100" y1="176" x2="100" y2="216" stroke="#1A1A1A" strokeWidth="1.5" />
    <text
      x="124"
      y="212"
      textAnchor="middle"
      fontFamily="Cormorant Garamond, serif"
      fontWeight="500"
      fontSize="42"
      fill="#1A1A1A"
    >
      A
    </text>
  </svg>
);
